import { addMilliseconds } from 'date-fns';
import { formatInTimeZone, getTimezoneOffset } from 'date-fns-tz';

import { useLocalState } from '@hooks/use-local-state';

export const timezoneFormatStorageKey =
  'logs_searchbar_duration_timezone_format';
export type TimezoneFormat = 'local' | 'utc';

export function useTimezoneFormat() {
  return useLocalState<TimezoneFormat>(timezoneFormatStorageKey, 'local');
}

export function getLocalTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function getTimezone(timezone: TimezoneFormat) {
  return timezone === 'utc' ? 'UTC' : getLocalTimezone();
}

export function getDateInTz(date: Date, timezone: TimezoneFormat) {
  const offset = getTimezoneOffset(getLocalTimezone(), date);

  if (timezone === 'utc') {
    return addMilliseconds(date, offset);
  }

  return date;
}

export function formatDatetime(
  date: Date | string,
  timezone: TimezoneFormat,
  formatStr: string
) {
  return formatInTimeZone(date, getTimezone(timezone), formatStr);
}
